export function groupBy<T>(
  array: T[],
  keySelector: (item: T) => string
): Record<string, T[]> {
  if (Object.groupBy) {
    return Object.groupBy(array, keySelector) as Record<string, T[]>;
  }

  return array.reduce(
    (result, item) => {
      const groupKey = keySelector(item);
      if (!result[groupKey]) {
        result[groupKey] = [];
      }
      result[groupKey].push(item);
      return result;
    },
    {} as Record<string, T[]>
  );
}
